import { BENCHMARK_SOURCE, mergeBenchmarkConfigs } from 'src/data/benchmark';
import type { DocumentVariation } from 'src/data/document';
// @ts-expect-error - no TypeScript definitions yet
import { useBenchmarkDebounced } from 'src/services/useBenchmarkDebounced';
// @ts-expect-error - no TypeScript definitions yet
import { useIsBenchmarkChannelConnected } from 'src/services/useIsBenchmarkChannelConnected';

interface Params {
  variation: DocumentVariation;
  projectId: string;
}

export const useBenchmarkConfigProps = ({ variation, projectId }: Params) => {
  const { benchmarkConfig, id, assetType, text } = variation;
  const isChannelConnected = useIsBenchmarkChannelConnected(assetType);

  const { benchmarkConfig: newBenchmarkConfig, loadingBenchmark } = useBenchmarkDebounced(
    {
      projectId,
      assetType,
      text,
      adAccountId: benchmarkConfig?.account?.id,
      userGoal: benchmarkConfig?.comparisonSet?.userGoal,
      variationId: id,
      comparisonSetName: benchmarkConfig?.comparisonSet?.name,
    },
    {
      disabled: !isChannelConnected,
      debounceTimeout: 500,
    }
  );

  return {
    benchmarkConfig: mergeBenchmarkConfigs(
      benchmarkConfig ?? newBenchmarkConfig,
      newBenchmarkConfig
    ),
    loadingBenchmark,
    counter: text?.length,
    source: BENCHMARK_SOURCE.sharedPage,
  };
};
